export function logClientError(scope: string, err: unknown): void {
  if (typeof console === 'undefined') return;
  if (import.meta.env.MODE === 'test') return;
  console.error(`[${scope}] error`, err);
}
